"use client";

import mixpanel from "mixpanel-browser";
import posthog from "posthog-js";

export function trackProductEvent(
  event: string,
  properties: Record<string, unknown> = {},
) {
  try {
    if (process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
      mixpanel.track(event, properties);
    }
  } catch {
    // Analytics must never interrupt a customer journey.
  }

  try {
    posthog.capture(event, properties);
  } catch {
    // Analytics must never interrupt a customer journey.
  }
}
